import { getListOfGatewayAndPriceEmail } from "../types/gateway_and_price_list_email_types";

const initState = {
  data: [],
  loading: false,
  error: null,
};

export default function gatewayAndPriceListEmailReducer(state = initState, action = {}) {
  switch (action.type) {
    case getListOfGatewayAndPriceEmail.GET_LIST_OF_GATEWAY_AND_PRICE_EMAIL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case getListOfGatewayAndPriceEmail.GET_LIST_OF_GATEWAY_AND_PRICE_EMAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: null,
      };
    case getListOfGatewayAndPriceEmail.GET_LIST_OF_GATEWAY_AND_PRICE_EMAIL_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
